import {ModalBase} from '../ModalBase'

const ModalDelete = (props: any) => {
  return (
    <ModalBase Styles={props.Styles}>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>{props.title}</h3>
          </div>
          <div className='form-separator'></div>
          <p>{props.detail}</p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={props.closeModalDelete}>
              <div>{props.messageClose || 'Cancelar'}</div>
            </button>
            <button className='m button delete w-inline-block' onClick={props.actionDelete}>
              <div>{props.messageAction || 'Eliminar'}</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalDelete
